export default {
    CARD: "card"
};
